import { FC } from 'react';

import { RootState } from '../../../redux/AppReducer';
import { IngredientCategory } from '../../../common/view-model';
import { IngredientFilterActions } from '../../../redux/ingredientFilter/IngredientFilterActions';
import './FilterIngredientTemplateComponent.scss';
import { useAppDispatch } from '../../../redux/store';
import { useSelector } from 'react-redux';

interface IFilterIngredientTemplateItemComponentProps {
	item: IngredientCategory;
	onClick: (item: IngredientCategory) => void;
	selectedFilter: IngredientCategory | undefined;
	allCategoriesId: string;
}
const FilterIngredientTemplateItemComponent: FC<IFilterIngredientTemplateItemComponentProps> = ({
	item,
	onClick,
	selectedFilter,
	allCategoriesId
}) => {
	const isCurrentFilter =
		selectedFilter?.id === item.id || (!selectedFilter && item.id === allCategoriesId);
	return (
		<div
			className={`filter-template-item-container ${isCurrentFilter ? 'current' : ''}`}
			onClick={() => onClick(item)}
		>
			{' '}
			<span className='filter-item-text'>{item.name}</span>
			{isCurrentFilter && <i className='ri-check-line'></i>}
		</div>
	);
};

interface IFilterIngredientTemplateComponentProps {
	onSelectFilter: () => void;
}
const FilterIngredientTemplateComponent: FC<IFilterIngredientTemplateComponentProps> = ({
	onSelectFilter
}) => {
	const dispatch = useAppDispatch();
	const allCategoriesId = 'all';
	const setSelectedFilter = (selectedFilter?: IngredientCategory) =>
		dispatch(IngredientFilterActions.setIngredientFilter(selectedFilter));
	const { selectedFilter, filterOptions: ingredientFilterOptions } = useSelector(
		(state: RootState) => state.appState.ingredientFilterState || {}
	);

	const handleFilterClick = (item: IngredientCategory) => {
		if (item.id === allCategoriesId) {
			setSelectedFilter(undefined);
		} else {
			setSelectedFilter(item);
		}
		onSelectFilter();
	};
	if (!ingredientFilterOptions || ingredientFilterOptions?.length === 0) {
		return null;
	}
	return (
		<div className='template-filter-container' onMouseLeave={onSelectFilter}>
			{ingredientFilterOptions.map((item: IngredientCategory) => {
				return (
					<FilterIngredientTemplateItemComponent
						key={item.id}
						item={item}
						onClick={handleFilterClick}
						selectedFilter={selectedFilter}
						allCategoriesId={allCategoriesId}
					/>
				);
			})}
		</div>
	);
};

export default FilterIngredientTemplateComponent;
